import React from 'react';
import { oyoFormView } from '../../../Enums';

const BottomNavigations = props => {
  let guc = props.guc;
  let gs = props.gs;

  return (
    <div>
      {props.oyoFormMode == oyoFormView.checkEarnings && false}

      {props.oyoFormMode == oyoFormView.homeBasic && false}

      {props.oyoFormMode == oyoFormView.otpScreen && (
        <div>
          <div
            className={'hover'}
            onClick={() => {
              props.changeFormScreen(oyoFormView.loginScreen);
            }}
            style={{...gs('botom_nav_form'),marginBottom:'11px'}}
          >
            <span>{guc('already_user')}</span>
            <span style={gs('blue_bold')}>{'  ' + guc('click_to_login')}</span>
          </div>
          {/*<div*/}
          {/*  className={'hover'}*/}
          {/*  onClick={() => {*/}
          {/*    props.changeFormScreen(oyoFormView.hotelBasic);*/}
          {/*  }}*/}
          {/*  style={gs('botom_nav_form')}*/}
          {/*>*/}
          {/*  <span>{guc('talk_to_repr')}</span>*/}
          {/*  <span style={gs('blue_bold')}>*/}
          {/*    {'  ' + guc('talk_to_repr_sub')}*/}
          {/*  </span>*/}
          {/*</div>*/}
        </div>
      )}

      {props.oyoFormMode == oyoFormView.signUpScreen && (
        <div>
          <div
            className={'hover'}
            onClick={() => props.changeFormScreen(oyoFormView.loginScreen)}
            style={gs('botom_nav_form')}
          >
            <span>{guc('already_user')}</span>
            <span style={gs('blue_bold')}>{'  ' + guc('login_here')}</span>
          </div>

          <div
            className={'hover'}
            onClick={() => props.changeFormScreen(oyoFormView.hotelBasic)}
            style={{...gs('botom_nav_form'),marginBottom:'11px'}}
          >
            <span>{guc('talk_to_repr')}</span>
            <span style={gs('blue_bold')}>
              {'  ' + guc('talk_to_repr_sub')}
            </span>
          </div>
        </div>
      )}

      {(props.oyoFormMode == oyoFormView.loginScreen ||
      props.oyoFormMode == oyoFormView.loginWithOtpStepOne ||
      props.oyoFormMode == oyoFormView.loginWithOtpStepTwo) && (
          <div
            className={'hover'}
            onClick={() => props.changeFormScreen(oyoFormView.otpScreen)}
            style={{...gs('botom_nav_form'),marginBottom:'11px'}}
          >
            <span>{guc('not_regis')}</span>
            <span style={gs('blue_bold')}>{'  ' + guc('sign_up')}</span>
          </div>
      )}

      {props.oyoFormMode == oyoFormView.hotelBasic && false}

      {props.oyoFormMode == oyoFormView.homeStepTwo && (
        <div>
          <div
            className={'hover'}
            onClick={() => props.changeFormScreen(oyoFormView.homeBasic)}
            style={{...gs('botom_nav_form'),marginBottom:'11px'}}
          >
            <span style={gs('blue_bold')}>{guc('go_to_prev_form')}</span>
            {/*<span style={gs('blue_bold')}>{'  ' + guc('click_to_reset')}</span>*/}
          </div>
        </div>
      )}
    </div>
  );
};

export default BottomNavigations;
